module.exports = __webpack_public_path__ + "static/wiz-janowo-4-2ab33dbe6110d348292272cbf0322236.jpg";